// extracted by mini-css-extract-plugin
export default {"actionsCell":"productMenuListItem_actionsCell__R9bwe","dropdownMenu":"productMenuListItem_dropdownMenu__pv2Lo"};